import { GTMEventTypes } from '@sial/common-utils'
import { ShareDialogItemTypes } from '@src/components/ShareDialog/ShareDialog'
import { sendEvent } from '@utils/analytics/coreAnalytics'

export const sendQuoteDetailsEvent = (
  action: string,
  quoteNumber: string,
  ga4Payload?: {
    clickAction: string
    elementType: string
    component: string
    linkText?: string
    linkUrl?: string
    quoteStatus: string
  }
) => {
  const basePayload = {
    event: 'quotation_page_click',
    click_type: 'quotation: detail page',
    click_action: ga4Payload?.clickAction,
    click_details: quoteNumber || undefined,
    element_type: ga4Payload?.elementType,
    component: ga4Payload?.component,
    link_text: ga4Payload?.linkText?.toLowerCase() || undefined,
    link_url: ga4Payload?.linkUrl || undefined,
    quote_status: ga4Payload?.quoteStatus.toLowerCase(),
  }
  sendEvent({ payload: basePayload })
}

export enum ShareItemDetailsModalEventAction {
  Close = 'close',
  Copy = 'copy',
  SendEmail = 'send email',
  Ignore = 'ignore',
}

export enum EventMethods {
  Email = 'email',
  CopyLink = 'copy link',
  Print = 'print',
}

export const sendShareDialogEvent = ({
  detail,
  contentType,
  method,
  elementText,
}: {
  detail: string
  contentType: ShareDialogItemTypes
  method: EventMethods
  elementText: string
}) => {
  sendEvent({
    payload: {
      event: 'share',
      content_type: `${contentType} confirmation`,
      component: 'modal',
      element_type: 'button',
      element_text: elementText,
      detail,
      method,
    },
  })
}

export const sendOrderCenterEvent = (
  eventAction: string,
  eventLabel: string
) => {
  sendEvent({
    eventType: GTMEventTypes.AnalyticsEvent,
    payload: {
      event: 'order_interaction',
      eventInteractionType: 0,
      section: 'orders',
      order_type: undefined,
      component: 'drop-down menu',
      element_type: 'button',
      core_event: 'no',
      user_detail: undefined,
      event_group: undefined,
      event_subgroup: undefined,
    },
  })
}
